import { Theme, createStyles } from '@material-ui/core';
import { light } from '@material-ui/core/styles/createPalette';

const styles = (theme: Theme) =>
  createStyles({
    testTitle: {
      fontSize: 20,
      lineHeight: '27px',
      color: '#333',
      '&> img': {
        width: 20,
      },
    },
    dateAndTime: {
      fontSize: 16,
      fontWeight: 400,
      color: '#666',
      lineHeight: '18px',
      marginTop: 10,
    },
    marginL10: {
      marginLeft: 10,
    },
    dialogTitle: {
      fontWeight: 600,
      fontSize: 20,
      color: '#333',
    },
    smallInfo: {
      fontSize: 12,
      lineHeight: '16px',
      color: '#666',
    },
    inputLable: {
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '22px',
      color: '#666',
      marginBottom: 8,
      display: 'inline-block',
      // '& span': {
      //   color: '#f50057',
      // },
    },
    customTextarea: {},
    manageTextarea: {
      '&>:nth-child(2)': {
        '&>:first-child': {
          marginTop: 0,
          borderRadius: 4,
        },
      },
    },
    searchBarChips: {
      height: 'auto',
      '&>div:nth-of-type(1)': {
        border: "1px solid #dfdfdf",
        borderRadius: 4,
        padding: '0 0 0 15px',
        '&>div:nth-of-type(1)': {
          '&>div:nth-of-type(1)': {
            '&>div:nth-of-type(1)': {
              '&>div:nth-of-type(1)': {
                overflow: 'initial',
                '&>div:last-of-type': {
                  marginTop: 'initial !important',
                  lineHeight: '30px',
                }
              }
            }
          }
        }
      },
      '& svg': {
        cursor: 'pointer'
      }
    },
    rejectRequestModal: {
      position: 'relative',
      maxHeight: '523px',
      minHeight: '303px',
      '&>div>div': {
        paddingTop: '0 !important',
        '&>div': {
          position: 'relative',
          padding: 0,
          '& .title': {
            fontSize: '24px',
            fontWeight: 600,
            lineHeight: '32px',
            color: '#333333',
            margin: '0',
            borderBottom: 'solid 1px #DCDCDC',
            padding: '16px 10px 14px',
            textAlign: 'center',
            position: 'sticky',
            top: 0,
            backgroundColor: '#ffffff',
            zIndex: 9,
            '& .closeIcon': {
              position: 'absolute',
              right: '22px',
              top: '24px',
              cursor: 'pointer',
            },
          },
        },
        '& .textareaContent': {
          padding: '24px 40px 0',
          maxHeight: 'calc(523px - 155px)',
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#ccc',
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#9b9b9b',
            outline: 'none',
            borderRadius: '10px',
          },
          '& textarea': {
            width: '100%',
            height: '124px',
            border: 'solid 1px #D8D8D8',
            borderRadius: '4px',
            color: '#333333',
            fontSize: '16px',
            fontWeight: 400,
            fontFamily: 'Nunito',
            padding: '10px 15px',
            resize: 'none',
            display: 'block',
            '&::-webkit-input-placeholder': {
              color: '#666666',
            },
            '&:-ms-input-placeholder': {
              color: '#666666',
            },
            '&::placeholder': {
              color: '#666666',
            },
            '&:focus': {
              outline: 'none',
            }
          },
        },
        '& .ps__rail-y': {
          display: 'none',
        }, 
        '&:last-child': {
          padding: '24px 40px !important',
          border: 0,
        }
      },
      '& .btnBlue': {
        padding: '0 20px',
        minWidth: '100px',
        height: '44px',
        fontSize: '16px',
        fontWeight: 400,
        margin: '0',
      },
    },
    coursePlanInfoBox: {
      backgroundColor: 'rgba(250, 74, 74, 0.1)',
      padding: '18px 18px 20px',
      '&.accepted': {
        backgroundColor: 'rgba(255, 194, 1, 0.1)',
      },
      '& .listingRow': {
        display: 'flex',
        marginBottom: '24px',
      },
      '& .listing': {
        display: 'flex',
        padding: 0,
        margin: 0,
        listStyle: 'none',
        '& li': {
          padding: '0 16px',
          fontSize: '20px',
          fontWeight: 400,
          color: '#333333',
          position: 'relative',
          '&::after': {
            content: "''",
            position: 'absolute',
            right: 0,
            width: '1px',
            height: '28px',
            backgroundColor: 'rgba(153, 153, 153, 0.4)',
          },
          "&:first-child": {
            paddingLeft: 0,
          },
          "&:last-child::after": {
            display: 'none',
          },
        },
      },
      '& .linkText': {
        fontSize: '16px',
        fontWeight: 600,
        color: '#1D7DEA',
        textDecoration: 'none',
        lineHeight: '22px',
        alignSelf: 'center',
        textTransform: 'capitalize',
        position: 'relative',
        '&::after': {
          content: "''",
          right: 0,
          top: 0,
          width: '1px',
          height: '28px',
          backgroundColor: 'rgba(153, 153, 153, 0.4)',
          margin: '0 15px',
          display: 'inline-block',
          verticalAlign: 'middle',
        },
        '&:last-child::after': {
          display: 'none',
        },
      },
      '& .awaitingApprovalRow': {
        display: 'flex',
        alignItems: 'center',
        '& p': {
          fontSize: '16px',
          fontWeight: 400,
          color: '#333333',
          margin: '0 15px 0 0',
          textTransform: 'capitalize',
          '& strong': {
            fontWeight: 700,
          }
        }
      },
    },
    coursePlan: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: "#fff",
    },

    coursePlanHeading: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: "20px 20px 0 20px",
      '& button': {
        margin: '0 15px',
      },
      '& h4': {
        fontSize: 24,
        lineHeight: '33px',
        color: "#333",
        margin: 0,
      },
      '& .coursePlanDropdownsRow': {
        display: 'flex',
      },
      '& .coursePlanDropdowns': {
        display: 'inline-flex',
        minWidth: '137px',
        position: 'relative',
        margin: '0 5px',
        '& .dropdownBox': {
          position: 'absolute',
        },
        '& .placeholderTitle': {
          position: 'relative',
          top: '1px',
          left: '1px',
          width: 'calc(100% - 2px)',
          height: '40px',
          padding: '0 39px 0 10px',
          backgroundColor: '#ffffff',
          borderRadius: '4px',
          zIndex: 1,
          pointerEvents: 'none',
          fontSize: '14px',
          fontWeight: 600,
          color: '#333333',
          whiteSpace: 'nowrap',
          display: 'inline-block',
          lineHeight: '42px'
        },
        '& .dropdownBox>div>div span:nth-child(2)': {
          position: 'relative',
          zIndex: 2,
          '& img': {
            width: '10px',
            filter: 'brightness(0.7) invert(0)',
          },
        },
        '& .dropdownBox>div>div:nth-child(2)': {
          width: 'calc(100% + 5px)',
          top: '49px',
          border: 'solid 1px #E6E6E6',
          boxShadow: '0px 5px 8px 0px rgba(0, 0, 0, 0.2)',
          padding: '4px 5px',
          '&>div>div>div': {
            fontSize: '14px',
            fontWeight: 600,
            color: '#333333',
            '&>div:nth-child(2)': {
              fontWeight: 400,
              fontSize: '12px',
            },
          },
        },
      },
    },
    tabArea: {
      backgroundColor: '#fff'
    },
    dateRange: {
      fontSize: 16,
      color: "#333",
      lineHeight: '20px',
      marginTop: 0,
    },
    customTabs: {
      backgroundColor: '#fff',
      '& ul': {
        paddingLeft: 0,
        '& li': {
          fontSize: 14,
          color: "#666",
          padding: "0 15px",
          cursor: 'pointer'
        }
      }
    },
    activeTab: {
      color: '#1d7dea!important',
      position: 'relative',
      fontWeight: 600,
      cursor: 'pointer',
      '&::before': {
        content: "''",
        width: '100%',
        height: 4,
        display: 'inline-block',
        position: 'absolute',
        left: 0,
        right: 0,
        top: 24,
        background: '#1d7dea',
        borderRadius: 4,
      }
    },
    linkCTA: {
      color: '#1d7dea',
      fontSize: 14,
      cursor: 'pointer',
    },
    customCalendar: {
      '& .rdrCalendarWrapper': {
        width: 'auto',
      },
      '& input': {
        paddingRight: 0,
      },
    },
    displayFlex: {
      display: 'flex',
      alignItems: 'center',
    },
    viewTestBtn: {
      fontSize: '14px',
      color: '#1d7dea',
      fontWeight: 700,
      textDecoration: 'none',
      textTransform: 'uppercase',
      display: 'block',
      marginLeft: 'auto',
      '&:hover': {
        cursor: 'pointer',
      }
    },
    disabledLink : {
      cursor: 'default',
      pointerEvents: 'none',
      textDecoration: 'none',
      fontSize: '14px',
      color: 'grey',
      fontWeight: 700,
      textTransform: 'uppercase',
      display: 'block',
      marginLeft: 'auto',
      '&:hover': {
        cursor: 'pointer',
      }
    },
    colorRed: {
      color: '#D9505D'
    },
    newValidCreateContent: {
      '&.css-tlfecz-indicatorContainer':{
        color:'#1d7dea',
        '&:hover':{
          color:'#1d7dea',
        },
        
      },
      
      validationSelect__menu:{
        marginTop:0,
      },
    },
    '.ContentMenu-basicSingle-408 .validationSelect__control .css-tlfecz-indicatorContainer:hover':{
      color:'#1d7dea',
    }
  });

export { styles };
